// Swap legacy homepage screenshots for current, real VinCentrix product captures.
// Image/layout styling is intentionally untouched.

const screenshotReplacements = {
  '/images/dashboard.png': '/images/homepage-dashboard.webp',
  '/images/simulator.png': '/images/homepage-vc-today.webp',
  '/images/analytics.png': '/images/homepage-analytics.webp',
  '/images/customers.png': '/images/homepage-hot-opportunities.webp',
  '/images/appointments.png': '/images/homepage-appraisals.webp'
};

const refreshHomepageScreenshots = () => {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;

  document.querySelectorAll('img').forEach(img => {
    const currentSrc = img.getAttribute('src');
    const nextSrc = screenshotReplacements[currentSrc];
    if (nextSrc) img.setAttribute('src', nextSrc);
  });
};

new MutationObserver(refreshHomepageScreenshots).observe(document.documentElement, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', refreshHomepageScreenshots, { once: true });
window.addEventListener('load', refreshHomepageScreenshots);
window.addEventListener('popstate', refreshHomepageScreenshots);
setTimeout(refreshHomepageScreenshots, 0);
setTimeout(refreshHomepageScreenshots, 150);
